<template>
<div>
    <v-dialog v-model="showPopup" width="800" persistent :fullscreen="$store.getters.width<=800">
        <v-card>
            <v-card-actions>
                <v-spacer/>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            
            <v-card-text>
                <iframe id="iFrameResizer0" style="height: 2100px; width: 100%; border: 0px; overflow: hidden;" title="iframe" src="https://www.canadahelps.org/en/dne/145480" scrolling="no"></iframe>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn @click="close">Close</v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default{
    mounted(){
        if(this.checkPath()){
            this.open()
        }
    },
    data(){
        return {
            showPopup: false
        }
    },
    methods: {
        checkPath(){
            let triggers = [
                'clinical_guides'
            ]            
            for(let i=0; i<triggers.length; i++){
                let string = triggers[i]
                let path = this.$route.path
                if(path.search(string)>=0){
                    return true
                }
            }
            return false
        },
        open(){            
            let donationPopup = this.cache.storage.local.get('donationPopup')
            this.showPopup = donationPopup && donationPopup.displayed ? false : true
        },
        close(){
            this.cache.storage.local.set('donationPopup',{displayed: true})
            this.showPopup = false
        }
    },
    computed: {
        language: function(){
            return this.$store.getters.language
        },
        path: function(){
            return this.$route.path
        }
    },
    watch: {
        path(){
            let isTriggered = this.checkPath()
            if(isTriggered){
                this.open()
            }
            
        }
    }
}
</script>